const maxFileSizeMB = 5; // 5MB
const maxFileSizeErrorMessage = `We only accept images under ${maxFileSizeMB}MB in size.`;
const maxFileSizeKB = maxFileSizeMB * 1024 * 1024; // Convert to bytes

const handlerErrorMessage = "There was an error creating the upload request.";
const uploaderErrorMesage = "Image failed to upload.";

const uploadImageToS3 = (
  uploadConfig,
  blobInfo,
  success,
  failure,
  progress,
) => {
  const xhr = new XMLHttpRequest();
  xhr.open("PUT", uploadConfig.presigned_upload_url);

  xhr.upload.onprogress = (e) => {
    progress((e.loaded / e.total) * 100);
  };

  xhr.onerror = () => {
    failure(uploaderErrorMesage, { remove: true });
  };

  xhr.onload = () => {
    if (xhr.status !== 200) {
      failure(uploaderErrorMesage, { remove: true });
      return;
    }

    // Replace the <img> tag's src attribute with the public location
    success(uploadConfig.public_url);
  };

  xhr.send(blobInfo.blob());
};

// Step 1: Get Presigned URL from server
// Step 2: Upload image to S3 using Presigned URL
const imageUploadHandler = (blobInfo, success, failure, progress) => {
  if (blobInfo.blob().size > maxFileSizeKB) {
    failure(maxFileSizeErrorMessage, { remove: true });
    return;
  }

  const xhr = new XMLHttpRequest();

  xhr.open(
    "GET",
    `${window.fileUploadRequestUrl}&filename=${blobInfo.filename()}&upload_type=image`,
  );
  // Set CSRF Token
  xhr.setRequestHeader(
    "X-CSRF-TOKEN",
    document.querySelector("meta[name='csrf-token']").getAttribute("content"),
  );

  xhr.onerror = () => {
    failure(handlerErrorMessage, { remove: true });
  };

  xhr.onload = () => {
    const response = JSON.parse(xhr.responseText);

    if (response && "status" in response && response.status === "success") {
      uploadImageToS3(response.data, blobInfo, success, failure, progress);
    } else {
      failure(handlerErrorMessage, { remove: true });
    }
  };

  xhr.send();
};

export default imageUploadHandler;
